import React from 'react';
import TiktokSyncProgressBar from '@/tiktok-platform/components/TiktokSyncProgressBar';
import { useTiktokSyncJobs } from '@/tiktok-platform/context/TiktokSyncJobContext';

/**
 * 全局同步进度：仅展示未被页面槽位认领的任务（切到其他页时仍可见）。
 * 样式与页面内槽位共用 TiktokSyncProgressBar。
 */
export default function TiktokGlobalSyncProgress() {
  const { globalBars, cancelTrack, cancellingIds } = useTiktokSyncJobs();

  if (!globalBars.length) return null;

  return (
    <div className="tiktok-global-sync" aria-live="polite">
      {globalBars.map((progress) => (
        <TiktokSyncProgressBar
          key={progress.trackId}
          progress={progress}
          onCancel={
            progress.status === 'queued' || progress.status === 'running'
              ? () => cancelTrack(progress.trackId)
              : undefined
          }
          cancelling={cancellingIds.has(progress.trackId)}
        />
      ))}
    </div>
  );
}
